import { render, staticRenderFns } from "./index.vue?vue&type=template&id=742ba2b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=742ba2b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ba2b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742ba2b4')) {
      api.createRecord('742ba2b4', component.options)
    } else {
      api.reload('742ba2b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=742ba2b4&scoped=true", function () {
      api.rerender('742ba2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialManagement/withdrawalRulesConfiguration/index.vue"
export default component.exports